import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = {
  class: "fa fa-exclamation-triangle text-danger ml-2",
  "aria-hidden": "true"
}
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "fw-bold"
}
const _hoisted_8 = {
  key: 0,
  class: "edit-row"
}
const _hoisted_9 = ["colspan"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "p-5 d-flex flex-column text-center text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-save fa-7x mr-2 animated slow flash infinite" }),
  /*#__PURE__*/_createElementVNode("div", { class: "big-text mt-1" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Save Vaccine Record in Progress...")
  ])
], -1 /* HOISTED */)
const _hoisted_11 = {
  key: 2,
  class: "text-center"
}
const _hoisted_12 = { class: "edit-row" }
const _hoisted_13 = ["colspan"]
const _hoisted_14 = { class: "table table-responsive-md border border-gray" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "Week"),
    /*#__PURE__*/_createElementVNode("th", null, "Ordered"),
    /*#__PURE__*/_createElementVNode("th", null, "Scheduled"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "table-empty"
}
const _hoisted_19 = ["colspan"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h3", null, "No Tasks Found.", -1 /* HOISTED */)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 2,
  class: "table-error"
}
const _hoisted_23 = ["colspan"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _component_FrequencyWatchHosForm = _resolveComponent("FrequencyWatchHosForm")!
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: _normalizeClass(`${_ctx.isEditRequested || _ctx.isRowExpanded ? 'edit-row' : ''}`)
    }, [
      _createCommentVNode(" uncomment this once frequency watch weekly endpoint is fixed "),
      _createCommentVNode(" <td v-if=\"!isRowExpanded\">\r\n            <i class=\"fa fa-plus-circle cursor-pointer\" @click=\"expandRow(frequencyItem)\"></i>\r\n        </td>\r\n        <td v-if=\"isRowExpanded\">\r\n            <i class=\"fa fa-minus-circle cursor-pointer\" @click=\"expandRow()\"></i>\r\n        </td> "),
      _createElementVNode("td", null, [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handlePatientNameClick(_ctx.frequencyItem)))
        }, [
          _createVNode(_component_EmptyTextHandler, {
            text: _ctx.frequencyItem.PatientName
          }, null, 8 /* PROPS */, ["text"])
        ])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.frequencyItem.BranchName
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.frequencyItem.Discipline
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.frequencyItem.Frequency
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.getFrequencyStatusName(_ctx.frequencyItem.FrequencyStatus)
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.formatDate(_ctx.frequencyItem.StartDate)
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.formatDate(_ctx.frequencyItem.EndDate)
        }, null, 8 /* PROPS */, ["text"])
      ]),
      (_ctx.frequencyItem.Variance === 0)
        ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.frequencyItem.VisitsScheduled
            }, null, 8 /* PROPS */, ["text"])
          ]))
        : (_openBlock(), _createElementBlock("td", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.frequencyItem.VisitsScheduled), 1 /* TEXT */),
              _withDirectives(_createElementVNode("i", _hoisted_4, null, 512 /* NEED_PATCH */), [
                [_directive_tooltip, { title: 'Scheduled visits don’t match ordered visits for the week.' }]
              ])
            ])
          ])),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.frequencyItem.VisitsOrdered
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.frequencyItem.Variance
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", _hoisted_5, [
        (!_ctx.isEditRequested)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                class: "btn table-btn btn-outline-info",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.messageUser()))
              }, " Message User ")
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.isEditRequested)
          ? (_openBlock(), _createElementBlock("i", _hoisted_7, "Action in Progress"))
          : _createCommentVNode("v-if", true)
      ])
    ], 2 /* CLASS */),
    (_ctx.isEditRequested)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
          _createElementVNode("td", {
            colspan: _ctx.columns,
            class: "p-3"
          }, [
            (_ctx.isEditInProgress)
              ? (_openBlock(), _createBlock(_component_FormSection, { key: 0 }, {
                  content: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1 /* STABLE */
                }))
              : (_openBlock(), _createBlock(_component_FrequencyWatchHosForm, {
                  key: 1,
                  "close-send-message": _ctx.cancel
                }, null, 8 /* PROPS */, ["close-send-message"])),
            (!_ctx.isEditInProgress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-primary btn-md mt-2",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancel()))
                  }, "Cancel")
                ]))
              : _createCommentVNode("v-if", true)
          ], 8 /* PROPS */, _hoisted_9)
        ]))
      : _createCommentVNode("v-if", true),
    _withDirectives(_createElementVNode("tr", _hoisted_12, [
      _createElementVNode("td", {
        colspan: _ctx.columns,
        class: "p-3"
      }, [
        _createElementVNode("table", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("tbody", null, [
            (_ctx.isLoading)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.loadingCount, (i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "table-loading",
                    key: i
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loadingCount, (i) => {
                      return (_openBlock(), _createElementBlock("td", { key: i }, _hoisted_17))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            (!_ctx.isLoading && !_ctx.isError && !_ctx.hasData)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                  _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_21, 8 /* PROPS */, _hoisted_19)
                ]))
              : _createCommentVNode("v-if", true),
            (!_ctx.isLoading && _ctx.isError)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                  _createElementVNode("td", { colspan: _ctx.columns }, [
                    _createVNode(_component_ErrorMessageHandler, {
                      title: "Frequency Watch list",
                      onTryAgain: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getWeeklyFrequencyWatch(_ctx.frequencyItem)))
                    })
                  ], 8 /* PROPS */, _hoisted_23)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          (!_ctx.isLoading && _ctx.hasData)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.page, (item) => {
                return (_openBlock(), _createElementBlock("tbody", {
                  key: item.PatientId
                }, [
                  _createElementVNode("tr", null, [
                    (!_ctx.isWeeklyRowExpanded)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                          _createElementVNode("i", {
                            class: "fa fa-plus-circle cursor-pointer",
                            onClick: ($event: any) => (_ctx.expandWeeklyRow(item))
                          }, null, 8 /* PROPS */, _hoisted_25)
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.isWeeklyRowExpanded)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_26, [
                          _createElementVNode("i", {
                            class: "fa fa-minus-circle cursor-pointer",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.expandWeeklyRow()))
                          })
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.StartOfWeek)) + "-" + _toDisplayString(_ctx.formatDate(item.EndOfWeek)), 1 /* TEXT */),
                    _createElementVNode("td", null, [
                      _createVNode(_component_EmptyTextHandler, {
                        text: item.VisitsOrdered
                      }, null, 8 /* PROPS */, ["text"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_EmptyTextHandler, {
                        text: item.VisitsScheduled
                      }, null, 8 /* PROPS */, ["text"])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn table-btn btn-outline-info",
                        onClick: ($event: any) => (_ctx.openAddTaskForm(item))
                      }, " Add Task ", 8 /* PROPS */, _hoisted_27)
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ])
      ], 8 /* PROPS */, _hoisted_13)
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.isRowExpanded]
    ])
  ], 64 /* STABLE_FRAGMENT */))
}